import {Kpi} from '@hconnect/common/types'
import {dataTestId} from '@hconnect/uikit'
import {Card, CardTitle} from '@hconnect/uikit/src/lib2'
import {Close, DeleteOutlined} from '@mui/icons-material'
import {Box, Button, IconButton} from '@mui/material'
import React, {FC, startTransition} from 'react'
import {useTranslation} from 'react-i18next'
import {useSearchParams} from 'react-router'

import {useConfirmDialog} from '../../../../../common/providers'
import {useDeleteKpi} from '../../hooks'

import {KpiForm} from './KpiForm'

import {useUrlParam} from '@settings/modules/routing'

type KpiCardProps = {
  kpi: Kpi
}

export const KpiCard: FC<KpiCardProps> = ({kpi}) => {
  const {t} = useTranslation()
  const [, setSearchParam] = useSearchParams()

  const plantCode = useUrlParam('plantCode')
  const {mutate: deleteKpi} = useDeleteKpi()
  const {openDialog} = useConfirmDialog()
  const {tagname, displayName, kpiDefinitionId, unit, kpiAssignment, kpiVisibilityFlags} = kpi
  const handleDeleteClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()

    openDialog({
      title: t('kpiCalculationSettings.label.kpiDeleteConfirmationTitle'),
      description: t('kpiCalculationSettings.label.kpiDeleteConfirmation', {
        kpiName: displayName
      }),
      mainAction: {
        text: t('common.delete'),
        color: 'error',
        icon: <DeleteOutlined />,
        onAction: () => deleteKpi({plantCode, kpiDefinitionId})
      },
      testId: 'delete_kpi_dialog'
    })
  }
  return (
    <Card
      headerContent={
        <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
          <CardTitle sx={{mb: 0}}>{t('kpiCalculationSettings.label.kpi')}</CardTitle>
          <Box sx={{display: 'flex', gap: 1.5}}>
            <Button
              variant="text"
              color="error"
              startIcon={<DeleteOutlined />}
              onClick={handleDeleteClick}
              {...dataTestId('kpi-section-remove-button')}
            >
              {t('kpiCalculationSettings.action.delete')}
            </Button>
            <IconButton
              sx={{p: 1, width: 42}}
              onClick={() => startTransition(() => setSearchParam({}))}
              {...dataTestId('kpi-section-close-button')}
            >
              <Close />
            </IconButton>
          </Box>
        </Box>
      }
      sx={{boxShadow: 'none', pt: 0}}
      {...dataTestId('kpi-card')}
    >
      <KpiForm
        kpiAggregationType={kpiAssignment.aggregationType}
        weightKpi={kpiAssignment.weightAssignmentId}
        kpiUnit={unit}
        kpiTagname={tagname}
        kpiDisplayName={displayName}
        kpiId={kpiDefinitionId}
        kpiVisibilityFlags={kpiVisibilityFlags}
      />
    </Card>
  )
}
